import { get, isArray, isObject, size } from 'lodash';

export default class Response {
  public rawResponse;
  public data;
  public error;
  public isSuccess;
  public isFailure;

  constructor(response, payloadPath = 'data') {
    this.rawResponse = response;
    this.data = get(response, payloadPath, response);
    this.error = false;
    this.isSuccess = true;
    this.isFailure = false;
  }

  getData = () => {
    return get(this, 'data');
  };

  getField = (key) => get(this, `data.${key}`);

  getCount = () => {
    if (isArray(this.data) || isArray(get(this.data, 'items'))) {
      return size(get(this.data, 'items', this.data));
    }
    if (isObject(this.data)) {
      return 1;
    }

    return 0;
  };

  getStatus = () => {
    return get(this.rawResponse, 'status', 503);
  };

  getError = (key?): Error => get(this.error, key, this.error);

  getErrorMessage = () => this.error.message;

  throwError = () => {
    //throw this.error;
  };

  isNotFound = () => this.getStatus() === 404;
}
